module.exports = __webpack_public_path__ + "static/media/brandLogo.4dbb3fcd.png";